import React from 'react';
function Header ()
{
  return (
    <header className="header w3-pale-green w3-round-jumbo w3-card-24 w3-animate-opacity">
      <h1 className="">Historical Society of Centinela Valley</h1>
      <a className="firstIcon" href="https://www.facebook.com/profile.php?id=100013308728792">
        <i className="fa fa-facebook-square"></i>
      </a>
    </header>
  );
}
export default Header;
